
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { BehaviorSubject, Observable } from "rxjs";

export abstract class AbUnidade extends AppService {

  abstract unidades: BehaviorSubject<Array<any>>;
  abstract divisoes: BehaviorSubject<Array<any>>;
  abstract temUnidades: boolean;
  abstract temDivisoes: boolean;
  abstract unidadeReadOnly: BehaviorSubject<boolean>;
  abstract saveDivisoes(entity: any);
  abstract saveUnidades(entity: any);
  abstract getAllDivisoes();
  abstract getAllDivisoesPublic();
  abstract getAllDivisoesFilter(filter: AppFilter);
  abstract getAllUnidadesFilter(filter: AppFilter);
  abstract deleteDivisao(id: number);
  abstract getAllUnidades();
  abstract deleteAllDivisoes();
  abstract verificarSeJaPossuiUnidades();
  abstract verificarSeJaPossuiDivisoes();
  abstract getAllUnidadesByPessoa();
  abstract getAllUnidadesByPessoaId(pessoaId);
  abstract getAllUnidadesByDivisoes(divisoesIds: any);
  abstract atualizarStatusUnidade(pessoasId: number, unidadeId: number): Observable<any>;
  abstract getUnidadesByDivisao(divisaoId: number);
}